import { Component, EventEmitter, HostListener, Input, Output, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { documentoValidator, somenteDigitos } from '../../../core/utils/documento.util';
import { Cliente } from '../../../models/cadastro.model';
import { CadastroService } from '../../../services/cadastro.service';

@Component({
  selector: 'app-documento-cliente-modal',
  standalone: true,
  imports: [ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './documento-cliente-modal.html',
  styleUrl: './documento-cliente-modal.css',
})
export class DocumentoClienteModal {
  private readonly cadastroService = inject(CadastroService);

  @Input() isOpen = false;
  @Input() idCliente!: number;
  @Input() nomeCliente = '';

  /** Emite o cliente atualizado após gravar o documento. */
  @Output() salvo = new EventEmitter<Cliente>();
  /** Emite quando o usuário cancela, sem alterações. */
  @Output() cancelado = new EventEmitter<void>();

  readonly carregando = signal(false);
  readonly erro = signal<string | null>(null);

  readonly form = new FormGroup({
    cpfCnpj: new FormControl<string>('', { nonNullable: true, validators: [documentoValidator] }),
  });

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: Event): void {
    if (!this.isOpen || this.carregando()) return;
    event.preventDefault();
    this.cancelar();
  }

  get salvarDesabilitado(): boolean {
    return this.form.invalid || this.carregando();
  }

  salvar(): void {
    if (this.salvarDesabilitado) return;
    this.carregando.set(true);
    this.erro.set(null);
    const digitos = somenteDigitos(this.form.controls.cpfCnpj.value);
    this.cadastroService.atualizarDocumentoCliente(this.idCliente, digitos).subscribe({
      next: cliente => {
        this.carregando.set(false);
        this.salvo.emit(cliente);
      },
      error: (e: HttpErrorResponse) => {
        this.carregando.set(false);
        this.erro.set(e?.error?.message || 'Não foi possível atualizar o documento do cliente.');
      },
    });
  }

  cancelar(): void {
    if (this.carregando()) return;
    this.cancelado.emit();
  }
}
